import { Tab, Tabs, styled as muiStyled } from '@mui/material'

export const AddPracticeComponentContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    width: 100%;
    flex-grow: 1;
`,
)

export const AddPracticeTab = muiStyled(Tab)(
  ({ theme }) => `
  color: #fff;
  // background: #000;
`,
)
export const AddPracticeTabs = muiStyled(Tabs)(
  ({ theme }) => `
  .MuiTabs-indicator {
    background-color: #7e6eb0 !important; 
  }
  .Mui-selected { 
    color: #7e6eb0 !important;
  }
  .MuiTabs-flexContainer{
    justify-content: center;
  }
`,
)
